import Accordion from './Accordion.vue'
export default Accordion



// WEBPACK FOOTER //
// ./node_modules/gvue/src/components/Accordion/index.js